import { render, staticRenderFns } from "./Appointments.vue?vue&type=template&id=6fd7d316&scoped=true&"
import script from "./Appointments.vue?vue&type=script&lang=ts&"
export * from "./Appointments.vue?vue&type=script&lang=ts&"
import style0 from "./Appointments.vue?vue&type=style&index=0&id=6fd7d316&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd7d316",
  null
  
)

export default component.exports